import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './index';

export type State = {
  currentServingOrder: GetServingOrderResponse;
};

const initialState: State = {
  currentServingOrder: {} as any,
};

const service = createSlice({
  name: 'service',
  initialState,
  reducers: {
    setCurrentServingOrder(state, { payload }: PayloadAction<GetServingOrderResponse>) {
      if (payload?.orderId) {
        state.currentServingOrder = payload;
      } else {
        state.currentServingOrder = {} as any;
      }
    },
  },
});

export const { setCurrentServingOrder } = service.actions;
export const selectCurrentServingOrder = (state: RootState) => state.service.currentServingOrder;

export default service.reducer;
